import React, { memo } from "react";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface tPaginationIndexProp {
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
	itemsPerPage: number;
	currentPage: number;
	totalPages: number;
	totalCount: number;
}

export const PaginationIndex = memo(({ setCurrentPage, itemsPerPage, currentPage, totalPages, totalCount }: tPaginationIndexProp) => {
	return (
		<div className='flex items-center justify-between space-x-2 py-4'>
			<div className='text-sm text-muted-foreground'>
				Hiển thị {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, totalCount)} trong tổng số {totalCount} kết quả
			</div>
			<div className='flex items-center space-x-2'>
				<Button variant='outline' onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
					<ChevronLeft className='h-4 w-4' />
					Trước
				</Button>
				<div className='flex items-center space-x-1'>
					{Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
						const page = i + 1;
						if (totalPages <= 5) {
							return page;
						}
						// Show pages around current page
						if (currentPage <= 3) {
							return page;
						}
						if (currentPage >= totalPages - 2) {
							return totalPages - 4 + i;
						}
						return currentPage - 2 + i;
					}).map((page) =>
						currentPage === page ? (
							<Button key={page + "d"} variant='edit' onClick={() => setCurrentPage(page)} className='w-9 h-9'>
								{page}
							</Button>
						) : (
							<Button key={page + "e"} variant='outline' onClick={() => setCurrentPage(page)} className='w-9 h-9'>
								{page}
							</Button>
						)
					)}
				</div>
				<Button variant='outline' onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
					Sau
					<ChevronRight className='h-4 w-4' />
				</Button>
			</div>
		</div>
	);
});
